import { homeSEOContent } from '@/mocks/seoContent';

export default function AboutSection() {
  const { aboutTitle, aboutBadge, aboutPoints, stats } = homeSEOContent;

  return (
    <section id="about" className="py-16 md:py-20 px-6 md:px-10 bg-secondary-50">
      <div className="max-w-7xl mx-auto">
        <div className="mb-14">
          <span className="inline-block px-4 py-1.5 bg-background-50 text-foreground-700 text-xs font-semibold rounded-full mb-6 tracking-wide">
            {aboutBadge}
          </span>
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-900 leading-tight max-w-3xl">
            {aboutTitle}
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8 mb-16">
          {aboutPoints.map((point, idx) => (
            <p key={idx} className="text-sm text-foreground-600 leading-relaxed">
              {point}
            </p>
          ))}
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8">
          {stats.map((stat) => (
            <div key={stat.label} className="text-center p-6 bg-background-50 rounded-xl border border-background-200/70">
              <p className="font-heading text-3xl md:text-4xl font-bold text-primary-600">{stat.value}</p>
              <p className="text-xs text-foreground-500 mt-2 font-medium uppercase tracking-wide">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}